module.exports = {
    "collectionLabel": `N\xe1vrhy`
};


//# sourceMappingURL=sk-SK.main.js.map
